import React, { useState } from 'react'
import mainAxios from '../../../services/mainAxios';
import { defaultTableRows } from '../../../services/data';
import { useAppContext } from '../../../AppContext';
import moment from 'moment';

const useSearchPurchase = () => {
  const [loading, setLoading] = useState(false);
    const defaultSortCriteria = {
    field: "recordDateTime",
    direction: "DESC",
  };
  const [tableRows, setTableRows] = useState({
    currentPage: 1,
    rowsPerPage: 30,
    totalRows: 0,
    sortCriteria: defaultSortCriteria,
  });
  const [invoices, setInvoices] = useState([]);
  const {user:[user],selectedCompany:[selectedCompany]} = useAppContext()

  const getFilteredResults = ({
    data,
    pageSize = 30,
    page = defaultTableRows.currentPage,
    sortCriteria = [defaultSortCriteria],
  }) => {
    setLoading(true);
    const filterData = data 
    filterData.params = {
      ...filterData.params,
      dataFrom: "DB",
    };

    let purchaseUnit =""

    let reqParams = {};
    Object.keys(filterData.params).forEach((param) => {
      if (filterData.params[param] !== "" && param !== "purchaseUnit") {
        if (
          param === "priority" ||
          param === "currency" ||
          param === "internalStatus" ||
          param === "purchaseStatus"
        ) {
          if (filterData.params[param]?.length > 0) {
            reqParams[param] = filterData.params[param].join(",");
          }
        } else {
          reqParams[param] = filterData.params[param];
        }
      }
    });

    if (purchaseUnit !== "") {
      reqParams.purchaseUnit = purchaseUnit;
    }

    return mainAxios
      .post("endpoint/v2/getMyPurchases", {
        ...filterData,
        fromDate: filterData.fromDate,
        toDate: filterData.toDate,
        params: { ...reqParams },
        value: null,
        pagination: {
          pageSize: pageSize,
          pageNumber: page,
        },
        nuis: user.companiesRights.find(
          (company) => company.id === parseInt(selectedCompany)
        )?.nuis,
        sortCriteria,
      })
      .then((res) => {
        setLoading(false);
        if (res?.data?.status) {
          const mappedInvocies=res.data.content.map(invoice=>{
            return {
              ...invoice,
              value:invoice.id,
              label:`${invoice.docNumber} - ${invoice.connectionTransactional?.name} - ${invoice.currency!="ALL"?invoice.amount:invoice.amountInAll} ${invoice.currency} - ${invoice.recordDateTime
                        ? moment(invoice.recordDateTime).format("DD/MM/YYYY HH:mm")
                        : ""}`
            }
          })
          setInvoices(mappedInvocies);
          setTableRows((tableRows) => ({
            ...tableRows,
            totalRows: res?.data?.totalSize,
          }));
          return true;
        }
        return false;
      })
      .catch(() => {
        setLoading(false);
        return false;
      });
  };

  return {getFilteredResults,loading,tableRows,invoices}
}

export default useSearchPurchase